import SVToasterThumbnails from '@apps/www/src/www/components/SVToasterThumbnails';
import { usePendingNotifications } from '@apps/www/src/www/hooks/usePendingNotifications';
import SVIconButton, { SVIconButtonSIZES } from '@pkgs/shared-client/components/SVIconButton';
import cn from '@pkgs/shared-client/helpers/cn';
import IconCloseSVG from '@pkgs/shared-client/img/icon-close-inlined.svg';
import { useState } from 'react';
import SVA from './SVA';
import SVButton from './SVButton';
import SVLink from './SVLink';

const SVPendingInviteBanner = () => {
	const { notifications: pendingInviteNotifications, hasPendingNotifications } =
		usePendingNotifications();
	const [currentIndex, setCurrentIndex] = useState(0);
	const [isVisible, setIsVisible] = useState(true);

	if (!hasPendingNotifications || !pendingInviteNotifications[0] || !isVisible) {
		return null;
	}

	const notification = pendingInviteNotifications[currentIndex];
	const userName = notification?.relatedUser?.name || notification?.relatedUser?.username;

	const handleContainerClick = () => {
		const boardUrl = notification?.relatedBoard?.url || '';
		if (boardUrl) {
			window.location.href = boardUrl;
		}
	};

	const handleClose = () => {
		if (currentIndex < pendingInviteNotifications.length - 1) {
			setCurrentIndex(currentIndex + 1);
		} else {
			setIsVisible(false);
		}
	};
	return (
		<div
			className={cn(
				'flex-center bg-primary hover:bg-primary/95 -sm:mb-6 relative m-auto mb-12 mt-5 flex h-[90px] w-[450px] max-w-xl cursor-pointer items-center rounded-xl shadow-lg ring-1 ring-black/5',
				'-sm:h-auto -sm:w-[calc(100%_-_var(--page-margin)_*_2)] -sm:mx-auto',
			)}
		>
			<div
				className={cn(
					'flex-center -sm:flex-col -sm:space-y-4 -sm:pr-8 flex h-full w-full items-center p-4 pr-10',
				)}
				onClick={handleContainerClick}
				title={notification?.relatedBoard?.name || notification?.relatedTeam?.name || ''}
			>
				<div className="flex flex-row items-center">
					<SVToasterThumbnails
						thumbnails={notification?.relatedBoard?.thumbnails}
						logoURL={notification?.relatedTeam?.logoURL || undefined}
						showAvatar={!notification?.relatedTeam?.logoURL}
						avatarURL={notification?.relatedUser?.avatarURL}
					/>
					<div className="ml-4 min-w-0 flex-1">
						<p className="line-clamp-3 text-sm">
							<SVA
								className="truncate font-semibold text-gray-700"
								to={notification?.relatedUser?.url}
							>
								{userName}
							</SVA>
							<span className="font-medium text-gray-400">
								{' '}
								invited you to collaborate on{' '}
							</span>
							<span className="truncate font-semibold text-gray-700">
								{notification?.relatedTeam?.name ||
									notification?.relatedBoard?.name}
							</span>
							<span className="font-medium text-gray-400">
								{' '}
								{notification.type === 'invite-team-user' ? 'team' : 'board'}
							</span>
						</p>
					</div>
				</div>
				<div className="-sm:justify-end -sm:w-full ml-4 flex space-x-4">
					<SVButton
						className="type-small text-primary rounded-xl bg-gray-800 px-5 py-3.5 font-medium transition-colors hover:bg-gray-600"
						Component={SVLink}
						to={
							notification?.relatedBoard?.acceptURL ||
							notification?.relatedTeam?.acceptURL ||
							''
						}
					>
						Accept
					</SVButton>
				</div>
			</div>
			<div className="absolute right-3 top-3">
				<SVIconButton
					onClick={handleClose}
					src={IconCloseSVG}
					label={currentIndex < pendingInviteNotifications.length - 1 ? 'Next' : 'Close'}
					size={SVIconButtonSIZES.SMALL}
					className="text-gray-400"
					iconClassName="w-2.5 h-2.5"
					disableHover
				/>
			</div>
		</div>
	);
};

export default SVPendingInviteBanner;
